import React, { useState } from "react";
import { Button, Stack } from "@mantine/core";
import McInputNew from "../McInput/McInputNew";

const ChangePassword: React.FC<{ onChangePassword: (password: string) => void }> = ({ onChangePassword }) => {
  const [newPassword, setNewPassword] = useState("");
  const [newPassswordAgain, setNewPasswordAgain] = useState("");
  const [passwordDontmatch, setPasswordDontMatch] = useState(false);

  const changePasssword = (e) => {
    e.preventDefault();
    if (newPassword !== newPassswordAgain) {
      return setPasswordDontMatch(true);
    }
    setPasswordDontMatch(false);
    onChangePassword(newPassword);
  };

  return (
    <form style={{ width: "100%" }} onSubmit={(e) => changePasssword(e)}>
      <Stack gap="xs">
        <div>
          <McInputNew
            required
            minLength={8}
            type="password"
            placeholder="Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div>
          <McInputNew
            required
            minLength={8}
            type="password"
            placeholder="Passord (igjen)"
            value={newPassswordAgain}
            onChange={(e) => setNewPasswordAgain(e.target.value)}
          />
        </div>
        <Button type="submit" color="secondary" className="mt-2" fullWidth>
          Bekrefte
        </Button>

        {passwordDontmatch === true && <p className="text-danger">Passordene er ikke like. Prøv igjen.</p>}
      </Stack>
    </form>
  );
};

export default ChangePassword;
